/* eslint-disable react-hooks/rules-of-hooks */
import { Card, Form } from '@deere/ux.uxframe-react';
import { useTranslation } from "react-i18next";
import { SCBM_INDIRECT } from '../../utils/surveyLiterals';
import { getGroupTierArray } from '../../utils/utils'
import { getTranslation, getAnswerLabel } from '../../utils/utils'


export default function Tier2ReviewSection({ sectionSurvey, answers }) {
    const { t } = useTranslation();
    if (!sectionSurvey)
        return <></>

    const tierForms = answers.filter(answer => answer.tierIndex > 0)
    const questions = sectionSurvey.questions.sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1);
    const tierContacts = getGroupTierArray(tierForms, questions, false , SCBM_INDIRECT);
    const questionNoTier = questions[7];//Question for no tier provide
    const answerNoTier = !tierContacts || tierContacts.length <= 0?getAnswerLabel(questionNoTier,answers):null;

    const createCheckRow = ( question ) => {
        let labels = getAnswerLabel(question, answers);
        labels = labels === '-' || labels === undefined?null:labels;
        return  labels?<Form.Group className='mb-4 pl-4'>
                    <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
                    {labels?labels.map(lab => <li key={lab}>{lab}</li>):''}
                </Form.Group>:null;
           
    }

    const createQuestions = ( question ) => {
        return <Form.Row className="d-block mb-4">
            <Form.Label className="uxf-label">{getTranslation(question,'text')}</Form.Label>
            <h6>{getAnswerLabel(question, answers)}</h6>
        </Form.Row>
    }
    
    return (<div>
        <Card>
            <Card.Body>
                <Card.Title className='pb-3'>
                    {getTranslation(sectionSurvey, 'description')} <small style={{ color: 'gray' }}>{t('t2_subtitle')} </small>
                </Card.Title>
                {createQuestions( questions[10] )}
                {createCheckRow(  questions[11] )}
                {createQuestions( questions[12] )}
                {
                    tierContacts && tierContacts.length > 0? tierContacts.map((con, idx) =>{
                        let answerOrdered = con.sort((a, b) => (a.questionId > b.questionId) ? 1 : -1)
                        return <div key={idx}>
                             <Form.Row>
                                <Form.Label className="uxf-label">{t('t2_supplier_name')}&nbsp;</Form.Label><Form.Label>{ answerOrdered[0].answer }&nbsp;</Form.Label>
                            </Form.Row>
                            <Form.Row>
                                <Form.Label className="uxf-label">{t('t2_critical')}&nbsp;</Form.Label><Form.Label>{answerOrdered[2].answer }&nbsp;</Form.Label>
                                <Form.Label className="uxf-label">{t('t2_address')}&nbsp;</Form.Label><Form.Label>{answerOrdered[3].answer }&nbsp;</Form.Label>
                            </Form.Row>
                            <Form.Row>
                                <Form.Label className="uxf-label">{t('t2_state_region')}&nbsp;</Form.Label><Form.Label>{answerOrdered[5].answer }&nbsp;</Form.Label>
                                <Form.Label className="uxf-label">{t('t2_city')}&nbsp;</Form.Label><Form.Label>{answerOrdered[4].answer }&nbsp;</Form.Label>                           
                                <Form.Label className="uxf-label">{t('t2_country')}&nbsp;</Form.Label><Form.Label>{answerOrdered[1].answer }&nbsp;</Form.Label>                          
                                <Form.Label className="uxf-label">{t('t2_zip')}&nbsp;</Form.Label><Form.Label>{answerOrdered[6].answer}&nbsp;</Form.Label>
                            </Form.Row> 
                           <br></br>
                        </div>}) : <></>
                }
                {
                   !tierContacts || tierContacts.length <= 0?<><Form.Row>
                                                                <Form.Label>{t('lbl_ph_t2_reason_header')}</Form.Label>
                                                                </Form.Row>
                                                                <Form.Row><Form.Label>{answerNoTier}</Form.Label></Form.Row></>:<></>
                }
            </Card.Body>
        </Card>
    </div>)
}